import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NSignInAccessLayout } from './sign-in-access-layout.component';

@Injectable({ providedIn: 'root' })
export class SignInAccessLayoutResolver implements Resolve<void | ICmsBlock<NSignInAccessLayout.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) {}
    resolve(): Promise<any> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NSignInAccessLayout.componentId }, undefined);
    }
}
